import script from "./fileCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./fileCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./fileCheckbox.vue?vue&type=style&index=0&id=0c264ec8&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c264ec8"]])

export default __exports__